import { render, staticRenderFns } from "./user_head.vue?vue&type=template&id=1e436754&scoped=true&"
import script from "./user_head.vue?vue&type=script&lang=js&"
export * from "./user_head.vue?vue&type=script&lang=js&"
import style0 from "./user_head.vue?vue&type=style&index=0&id=1e436754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e436754",
  null
  
)

export default component.exports